export enum PDFReportBranding {
  whitelabel = 'whitelabel',
  shortpoint = 'shortpoint',
  userway = 'userway',
}

export enum PDFReportResult {
  'success',
  'error',
}

export enum IssueType {
  a = 'A',
  aa = 'AA',
  aaa = 'AAA',
}

export const CHART_COLOR = {
  red: {
    A: '#5B0808',
    AA: '#A40C0C',
    AAA: '#D60F0F',
  },
  green: {
    A: '#024A4A',
    AA: '#035C5D',
    AAA: '#357D7D',
  },
};

export interface ViolationIssue {
  count: number;
}

export interface Violations {
  totalCount: number;
  A: ViolationIssue;
  AA: ViolationIssue;
  AAA: ViolationIssue;
}

export const initialViolations: Violations = {
  totalCount: 0,
  A: {
    count: 0,
  },
  AA: {
    count: 0,
  },
  AAA: {
    count: 0,
  },
};

export interface ViolationRule {
  count: number;
  title: string;
  level: string;
}
